module.exports = __webpack_public_path__ + "static/media/dark.13098868.png";